import Home from "../views/Home.vue";
//import i18n from "../i18n";

const routes = [
  {
    path: "",
    component: () => import("../layouts/Main.vue"),
    children: [
      {
        path: "/",
        name: "Home",
        component: Home
      },
      {
        path: "/lang/:locale",
        name: "HomeWithLocale",
        component: Home
      },
      {
        path: "/about",
        name: "About",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue"),
      },
      {
        path: "/about/:locale",
        name: "AboutWithLocale",
        component: () =>
          import(/* webpackChunkName: "about" */ "../views/About.vue"),
      },
      {
        path: "/register",
        name: "Register",
        component: () =>
          import(/* webpackChunkName: "register" */ "../views/Register.vue"),
      },
      {
        path: "/register/:locale",
        name: "RegisterWithLocale",
        component: () =>
          import(/* webpackChunkName: "register" */ "../views/Register.vue"),
      },
      {
        path: "/contact",
        name: "Contact",
        component: () =>
          import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
      },
      {
        path: "/contact/:locale",
        name: "ContactWithLocale",
        component: () =>
          import(/* webpackChunkName: "contact" */ "../views/Contact.vue"),
      },

      {
        path: "/articles/:id",
        name: "Article",
        component: () =>
          import(/* webpackChunkName: "article" */ "../views/Article.vue"),
      },
      {
        path: "/dentists",
        name: "SearchDentist",
        component: () =>
          import(/* webpackChunkName: "SearchDentist" */ "../views/SearchDentist.vue"),
      },
      {
        path: "/doctors",
        name: "SearchDoctor",
        component: () =>
          import(/* webpackChunkName: "SearchDoctor" */ "../views/SearchDoctor.vue"),
      },
      {
        path: '*',
        name: 'NotFound',
        component: () =>
          import(/* webpackChunkName: "notfound" */ "../views/NotFound.vue"),
      }
    ],
  },
];

export default routes;
